const advantages = [
  {
    icon: 'ri-flask-line',
    title: '專業研發團隊',
    desc: '專業團隊以自然為根本，堅持自然選材，且持續追蹤最新原料趨勢與配方技術',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: '品質認證保證',
    desc: '生產工廠擁有 HACCP 、 ISO22000 等國際品質認證',
  },
  {
    icon: 'ri-time-line',
    title: '注重法規細節',
    desc: '為您把關食品相關法規，打造低風險產品',
  },
  {
    icon: 'ri-shield-check-line',
    title: '協助檢驗送審',
    desc: '協助客戶完成產品標示，並協助送審至第三方檢驗單位',
  },
  {
    icon: 'ri-file-text-line',
    title: '彈性客製化',
    desc: '針對客戶需求做彈性的客製化製程，幫助您輕鬆打造產品',
  },
  {
    icon: 'ri-lock-line',
    title: '快速交期',
    desc: '從樣品確認到大量生產，幫助您有效縮短產品上市時程',
  },
];

export default function CoopAdvantagesSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
            合作優勢
          </span>
          <h2 className="text-[#1a2e1a] font-bold mb-4">
            與康永合作的六大優勢
          </h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
            選擇康永生技，讓您的代工之路更順暢、更安心
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {advantages.map((a) => (
            <div
              key={a.title}
              className="flex gap-5 p-6 rounded-2xl bg-[#f7faf7] hover:bg-green-50 border border-transparent hover:border-green-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-white rounded-xl flex-shrink-0 border border-green-100">
                <i className={`${a.icon} text-[#4CAF50] text-xl`} />
              </div>
              <div>
                <h3 className="text-[#1a2e1a] font-bold text-[1rem] mb-2">{a.title}</h3>
                <p className="text-gray-500 text-[0.875rem] leading-[1.75]">{a.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
